import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getPublicSettings } from "@/lib/api";

const SettingsContext = createContext({
    settings: null,
    refresh: () => {},
});

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState(null);

    const load = useCallback(async () => {
        try {
            const s = await getPublicSettings();
            setSettings(s);
        } catch {
            setSettings({
                phone: "",
                email: "",
                address: "",
                office_hours: "",
                chat_online: false,
                adviser_name: "Adviser",
                chat_welcome: "",
                fca_number: "",
            });
        }
    }, []);

    useEffect(() => {
        load();
        const id = setInterval(load, 45000); // refresh online status every 45s
        return () => clearInterval(id);
    }, [load]);

    return (
        <SettingsContext.Provider value={{ settings, refresh: load }}>
            {children}
        </SettingsContext.Provider>
    );
}

export const useSettings = () => useContext(SettingsContext);
